import { render, staticRenderFns } from "./SeminarDetails.vue?vue&type=template&id=60444872&scoped=true&"
import script from "./SeminarDetails.vue?vue&type=script&lang=js&"
export * from "./SeminarDetails.vue?vue&type=script&lang=js&"
import style0 from "./SeminarDetails.vue?vue&type=style&index=0&id=60444872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60444872",
  null
  
)

export default component.exports